// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oe4e","content":"styles_content__DdUaw","tableWrap":"styles_tableWrap__2Xo-2"};